import React, { useEffect, useState } from 'react';
import {Table} from 'reactstrap'
import { getUserList, ActiveDeactiveUsers } from './_users_srv';
import { AppAlert } from '../../utils/index';
import {BanBtn, UnBanBtn} from '../../components/Btn/extra.js';

function Users(props) {
    const [userList, setUserList] = useState([])
    function callUserList(){
        getUserList().then(res => {
            if (res.status === 200) {
                if (res.data)
                    if (res.data.length > 0) {
                        setUserList(res.data)
                    }
            }
        }).catch(err => {
            if (err.response)
                AppAlert(err.response.status, err.response.data)
        })
    }
    useEffect(() => {
        callUserList()
    }, [])
    const ActiveDeactiveUser = (uid, status) =>{
        ActiveDeactiveUsers(uid, status).then(res=>{
            if(res.status === 200){
                callUserList()
                AppAlert(200, res.data)
            }
        }).catch(err=>{
            console.log(err)
            console.log(err.response)
            if(err.response)
            AppAlert(err.response.status, err.response.data)
        })
    }
    function renderTableRow(e, index) {
        return (
            <tr key={index}>
                <th scope="row">{e.Id}</th>
                <td>{e.FirstName}</td>
                <td>{e.LastName}</td>
                <td>{e.NickName}</td>
                <td>{e.RoleName}</td>
                <td><a href={'tel:+98'+e.MobileNumber}>{e.MobileNumber}</a></td>
                <td>{e.RegDate}</td>
                <td>{e.isActive === 1 ? 'بله':'خیر'}</td>
                <td>{e.isActive === 1 ? <BanBtn onClick={()=>ActiveDeactiveUser(e.Id, 0)}/> : <UnBanBtn onClick={()=>ActiveDeactiveUser(e.Id, 1)}/>}</td>
            </tr>
        )
    }
    return (
        <div>
            <Table className="whiteBox ScollingTable">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>نام</th>
                        <th>نام خانوادگی</th>
                        <th>نام کاربری</th>
                        <th>نقش</th>
                        <th>شماره تماس</th>
                        <th>تاریخ ثبت نام</th>
                        <th>وضعیت اکانت</th>
                        <th>عملیات</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        userList.length >0 ?
                        userList.map((item, index) => {
                            return renderTableRow(item, index);
                        }) : null
                    }
                </tbody>
            </Table>
        </div>
    )
}

export default Users;